export enum GTMAffiliationCollection {
  operator = "fornitore_operativo",
  admin = "amministratore",
  citizen = "utente_cliente",
}
